import { FrameComponentOptions } from "../types/FrameComponentOptions.js";
import { FrameComponent } from "../web-components/frames/frame-component.js";

export class FrameNavigation {
    private static instance: FrameNavigation | null = null;
    private currentZIndex = 1050; // Bootstrap default z-index for modals
    private frameHistory: FrameComponent[] = [];
    
    public newZIndex(): number {
        this.currentZIndex += 1;
        return this.currentZIndex;
    }   
    
    private constructor() {
        // Implementazione della logica di navigazione tra frame
    }
    openFrame(url: string, options: FrameComponentOptions = {}): FrameComponent {
        const frameComponent = document.createElement('frame-component') as FrameComponent;
        frameComponent.style.zIndex = this.newZIndex().toString();
        document.body.appendChild(frameComponent);
        frameComponent.initialize({
            src: url,
            ...options
        });
        
        // Aggiungi il frame allo stack della history
        this.frameHistory.push(frameComponent);
        
        frameComponent.addEventListener('close', () => {
            this.close(frameComponent);
        });
        frameComponent.addEventListener('back', () => {
            this.close(frameComponent);
        });
        return frameComponent;
    }
    
    private removeFrameFromHistory(frameComponent: FrameComponent): void {
        const index = this.frameHistory.indexOf(frameComponent);
        if (index > -1) {
            this.frameHistory.splice(index, 1);
        }
    }
    private close(frameComponent: FrameComponent): void {
        frameComponent.remove();
        document.dispatchEvent(new CustomEvent('frame-closed', { detail: { frameComponent } }));
        this.removeFrameFromHistory(frameComponent);
    }
       
    public static getInstance(): FrameNavigation {
        if (FrameNavigation.instance === null) {
            FrameNavigation.instance = new FrameNavigation();
        }
        return FrameNavigation.instance;
    }
}
const frameNavigation = FrameNavigation.getInstance();

export default frameNavigation;